import React, { SVGProps } from "react";

export default function SupInfoCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.0394 3.864H9.24737V5.512H11.0394V3.864Z" fill="currentColor" />
      <path d="M10.9274 13.976V7.24H7.19937V8.264H9.67937V13.976H6.63937V15H13.7434V13.976H10.9274Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM17.2 10C17.2 13.9765 13.9765 17.2 10 17.2C6.02355 17.2 2.8 13.9765 2.8 10C2.8 6.02355 6.02355 2.8 10 2.8C13.9765 2.8 17.2 6.02355 17.2 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
